// METIS Hub wording — namespace "admin" (ko), 1061 keys.
// Extracted once from the approved mockup (poc-plan/mockup-src: js/screens/admin.js App.addI18n).
// From now on this file is the source: edit it by hand (keep ko/en keys in pairs — packages/i18n tests check
// key parity, Hangul in English text and the plan 9.1.3 wording rules). Placeholders: {name}, plural {n|one|other}.
const admin: Record<string, string> = {
  "admin.rp.review.sumUnknown": "검토할 부여 {n}건 중 {u}건은 사용 기록 확인 전이에요. 확인된 90일 미사용은 {d}건이에요.",
  "admin.rp.review.unknown": "사용 기록 확인 전",
  "admin.rp.review.unknownD": "기록을 확인하지 못한 권한은 미사용으로 판단하지 않아요.",
  "admin.rp.review.keepExpiry": "유지는 기존 권한과 만료일을 그대로 둬요. 만료일을 늘리려면 별도 부여·승인이 필요해요.",

  "admin.act.role.expiry_deferred": "마지막 관리자 만료 유예",
  "admin.rp.grant.expiryDeferred": "마지막 관리자 보호로 만료를 미뤘어요",
  "admin.pc.title": "PC에서 편집해 주세요",
  "admin.pc.roles": "휴대폰에서는 역할별 요약과 승인만 할 수 있어요. 권한 표·역할 주기·서비스 계정은 PC에서 바꿔 주세요.",
  "admin.pc.policy": "휴대폰에서는 지금 정책을 읽기만 해요. 상한·안내문·가림 규칙·보관 기간·열람 통제 값은 PC에서 바꿔 주세요.",
  "admin.pc.cost": "휴대폰에서는 단가표를 읽기만 해요. 새 가격 버전은 PC에서 만들어 주세요.",
  "admin.cond.all": "회사 전체",
  "admin.undone": "되돌렸어요. 되돌린 일도 이력에 남았어요.",
  "admin.snack.relogin": "대상자 {n}명은 다시 로그인하게 돼요",
  "admin.noExpiry": "만료 없음",
  "admin.daysLeft": "{n}일 남음",
  "admin.more": "외 {n}명",
  "admin.reasonMin": "사유를 {n}자 이상 적어 주세요.",
  "admin.chars": "{n}자",
  "admin.days": "{n}일",
  "admin.years": "{n}년",
  "admin.months": "{n}개월",
  "admin.min": "{n}분",
  "admin.demoTag": "목업 전용",
  "admin.tech.show": "기술 상세 보기",
  "admin.tech.action": "행위 코드",
  "admin.tech.target": "대상 유형",
  "admin.tech.ids": "내부 id",
  "admin.tech.raw": "원래 세부",
  "admin.tech.entry": "이력 id",
  "admin.tech.setting": "설정 이름",
  "admin.tech.value": "지금 값",
  "admin.go.support": "지원표에서 보기",
  "admin.go.connect": "도구 연결에서 보기",
  "admin.empty.adm-matrix.w": "역할 표가 비어 있어요.",
  "admin.empty.adm-matrix.n": "역할이 없으면 모두 일반 사용자 권한(본인 기록)만 가져요.",
  "admin.empty.adm-roles-list.w": "아직 만든 역할이 없어요.",
  "admin.empty.adm-roles-list.n": "기본 3역할은 늘 있어요. 프리셋을 복사해 새 역할을 만드세요.",
  "admin.empty.adm-rules.w": "규칙을 불러오지 못했어요.",
  "admin.empty.adm-rules.n": "규칙을 못 불러와도 서버는 같은 규칙으로 막아요.",
  "admin.empty.adm-grant.w": "역할을 줄 수 있는 사람이 없어요.",
  "admin.empty.adm-grant.n": "내 범위 밖의 사람에게는 역할을 줄 수 없어요.",
  "admin.empty.adm-grants.w": "아직 역할을 준 사람이 없어요.",
  "admin.empty.adm-grants.n": "모든 사람은 일반 사용자 역할을 함께 가져요.",
  "admin.empty.adm-cap.w": "아직 회사 상한을 정하지 않았어요.",
  "admin.empty.adm-cap.n": "정하기 전에는 기본 정보만 남아요.",
  "admin.empty.adm-notice.w": "아직 게시한 안내문이 없어요.",
  "admin.empty.adm-notice.n": "안내문을 게시하고 동의를 받기 전에는 아무 기록도 저장하지 않아요.",
  "admin.empty.adm-notice-ver.w": "게시한 버전이 없어요.",
  "admin.empty.adm-notice-ver.n": "첫 버전을 게시하면 여기에 쌓여요.",
  "admin.empty.adm-red.w": "가림 규칙이 없어요.",
  "admin.empty.adm-red.n": "규칙이 없으면 글 속 비밀값이 그대로 저장될 수 있어요.",
  "admin.empty.adm-red-pv.w": "미리 볼 글이 없어요.",
  "admin.empty.adm-red-pv.n": "가짜 값을 넣어 가림 결과를 확인하세요.",
  "admin.empty.adm-red-paths.w": "비밀 파일 경로 규칙이 없어요.",
  "admin.empty.adm-red-paths.n": "규칙이 없어도 CLI 자격 증명 파일은 늘 막아요.",
  "admin.empty.adm-ret.w": "보관 기간 표가 비어 있어요.",
  "admin.empty.adm-ret.n": "표가 없으면 기본값(글 30일·사용량 180일)으로 지워요.",
  "admin.empty.adm-acc.w": "열람 통제 값을 불러오지 못했어요.",
  "admin.empty.adm-acc.n": "값을 못 불러와도 흐름은 꺼지지 않고 기본값(60분·10자·10분)으로 동작해요.",
  "admin.empty.adm-sg.w": "소집단 하한 값을 불러오지 못했어요.",
  "admin.empty.adm-sg.n": "값을 못 불러와도 3명보다 적으면 가려요.",
  "admin.empty.adm-vs.w": "정렬 설정을 불러오지 못했어요.",
  "admin.empty.adm-vs.n": "설정을 모르면 이름순으로만 보여요.",
  "admin.empty.adm-pol-hist.w": "아직 정책을 바꾼 이력이 없어요.",
  "admin.empty.adm-pol-hist.n": "저장하면 바뀐 값마다 여기에 남아요.",
  "admin.empty.adm-integ.w": "아직 이력이 없어요.",
  "admin.empty.adm-integ.n": "처음 로그인하면 이력이 쌓이기 시작해요.",
  "admin.empty.adm-grades.w": "아직 이력이 없어요.",
  "admin.empty.adm-grades.n": "이력이 쌓이면 등급마다 보관 기간을 따라요.",
  "admin.empty.adm-c1.w": "오늘 받은 기록이 없어요.",
  "admin.empty.adm-c1.n": "받은 기록이 없다고 아무도 안 쓴 건 아니에요. 연결 상태를 확인하세요.",
  "admin.empty.adm-c2.w": "PC 도우미 정보가 없어요.",
  "admin.empty.adm-c2.n": "선택 모듈이라 켜지 않으면 비어 있어요.",
  "admin.empty.adm-gap.w": "수집 공백 기록이 없어요.",
  "admin.empty.adm-gap.n": "공백이 없다고 모든 기기가 보낸 건 아니에요.",
  "admin.empty.adm-drop.w": "버린 기록이 없어요.",
  "admin.empty.adm-drop.n": "규칙에 맞지 않는 기록이 오면 이유별 건수만 여기에 보여요.",
  "admin.empty.adm-unk.w": "처음 보는 이름이 없어요.",
  "admin.empty.adm-unk.n": "처음 보는 이벤트가 오면 이름과 건수만 여기에 보여요.",
  "admin.empty.adm-ver.w": "버전 정보가 없어요.",
  "admin.empty.adm-ver.n": "연결된 CLI가 기록을 보내면 버전이 보여요.",
  "admin.empty.adm-health.w": "서버 상태를 불러오지 못했어요.",
  "admin.empty.adm-health.n": "수집은 따로 돌아가므로 기록이 멈춘 건 아닐 수 있어요.",
  "admin.empty.adm-kinds.w": "이 조건에서 비용 기록이 없어요.",
  "admin.empty.adm-kinds.n": "비용 기록이 없다고 AI를 안 쓴 건 아니에요. 비용을 보내지 않는 도구도 있어요.",
  "admin.empty.adm-price.w": "단가표가 없어요.",
  "admin.empty.adm-price.n": "단가표가 없으면 게이트웨이 호출의 비용을 계산하지 않아요.",
  "admin.empty.adm-budget.w": "예산 모듈이 꺼져 있어요.",
  "admin.empty.adm-budget.n": "2차 범위 선택 모듈이라 켜기 전에는 한도가 없어요.",
  "admin.roles.desc": "역할 {r}개 · 권한 키 {k}개(6묶음) · 승인 대기 {p}건",
  "admin.roles.copy": "역할 복사",
  "admin.roles.new": "새 역할 만들기",
  "admin.roles.tabs": "역할·권한 보기",
  "admin.roles.tab.matrix": "역할별 권한",
  "admin.roles.tab.grant": "사람에게 역할 주기",
  "admin.roles.tab.approvals": "승인 대기",
  "admin.roles.tab.service": "서비스 계정",
  "admin.roles.kpi.roles": "역할",
  "admin.roles.kpi.rolesHint": "기본 {b} · 프리셋 {p} · 사용자 정의 {c}",
  "admin.roles.kpi.text": "남의 글을 여는 역할",
  "admin.roles.kpi.textHint": "모두 고정 통제 흐름을 거쳐요",
  "admin.roles.kpi.pending": "승인 대기",
  "admin.roles.kpi.pendingHint": "요청한 사람과 승인하는 사람은 달라요",
  "admin.roles.kpi.expiry": "만료일이 꼭 필요한 부여",
  "admin.roles.kpi.expiryHint": "만료일 없음 {n}건",
  "admin.roles.kpi.expiryOk": "모두 만료일이 있어요",
  "admin.roles.corner": "권한",
  "admin.roles.kind.base": "기본 · 읽기 전용",
  "admin.roles.people": "{n}명",
  "admin.roles.everyone": "모든 사람",
  "admin.roles.nobody": "아직 가진 사람이 없어요",
  "admin.roles.dual": "2인",
  "admin.roles.cell.press": "눌러서 바꾸기",
  "admin.roles.cell.pending": "{to}{ro} 올리는 요청이 승인을 기다려요({id})",
  "admin.roles.cell.selfNo": "내가 가진 역할은 고칠 수 없어요(자기 권한 올리기 금지)",
  "admin.roles.matrix.q": "역할마다 무엇을 볼 수 있나요?",
  "admin.roles.matrix.tech": "권한 키 35개 × 보기 범위(꺼짐·본인·팀·전체) · 6묶음으로 접기",
  "admin.roles.matrix.sum": "역할 {r}개 중 {n}개가 남의 질문·답변 글을 열 수 있어요({names}).",
  "admin.roles.matrix.expand": "모두 펼치기",
  "admin.roles.matrix.collapse": "모두 접기",
  "admin.roles.matrix.readonly": "역할 정의는 회사 전체 범위의 역할·권한 관리자만 고쳐요. 나는 {teams} 사람에게 역할을 주고 거두는 일만 해요.",
  "admin.roles.matrix.src": "마지막 변경 {date} · {who}",
  "admin.roles.legend.lock": "기본 역할은 읽기 전용이에요(복사해서 고치세요)",
  "admin.roles.legend.team": "팀 = 역할을 줄 때 정한 적용 팀이에요. 자기 소속 팀이 저절로 들어가지 않아요.",
  "admin.roles.legend.pend": "승인을 기다리는 칸",
  "admin.roles.pop.kicker": "{role} 역할",
  "admin.roles.pop.scope": "보기 범위",
  "admin.roles.pop.holders": "이 역할을 가진 사람 {n}명은 바꾸면 다시 로그인하게 돼요.",
  "admin.roles.pop.dual": "올리면 2인 승인이 필요해요. 승인되면 안내문 ‘누가 볼 수 있나요’가 함께 바뀌어요.",
  "admin.roles.pop.exceeds": "내 권한보다 넓은 범위는 줄 수 없어요",
  "admin.roles.pop.pending": "이미 {to}{ro} 올리는 요청({id})이 승인을 기다려요. 승인 대기 탭에서 먼저 처리하세요.",
  "admin.roles.changed": "{role} · {perm} 권한을 {to}{ro} 바꿨어요",
  "admin.roles.list.q": "어떤 역할이 있고 누가 가졌나요?",
  "admin.roles.list.tech": "기본 3 · 프리셋 5 · 사용자 정의 · 묶음별 가장 넓은 범위",
  "admin.roles.list.sum": "일반 사용자 말고 다른 역할도 가진 사람은 {n}명이에요.",
  "admin.roles.based": "{base} 복사본",
  "admin.roles.mfa": "다단계 인증 필수",
  "admin.roles.pledge": "금지 용도 약정",
  "admin.roles.preview": "미리 보기",
  "admin.roles.copyThis": "복사",
  "admin.roles.delete": "지우기",
  "admin.roles.deleteTitle": "이 역할을 지울까요?",
  "admin.roles.deleteBody": "‘{role}’ 역할을 지워요. 가진 사람과 승인 대기가 없을 때만 지울 수 있어요.",
  "admin.roles.deleted": "‘{role}’ 역할을 지웠어요",
  "admin.rules.q": "권한은 어떤 규칙으로 바꾸나요?",
  "admin.rules.tech": "위임 규칙 · 서버가 바꿀 때마다 검사해요",
  "admin.rules.sum": "아래 7가지를 어기는 변경은 막고, 막은 일도 이력에 남겨요.",
  "admin.rules.1": "기본 3역할(관리자·매니저·일반 사용자)은 읽기 전용이에요. 복사해서 고치세요.",
  "admin.rules.2": "자기에게 역할을 주거나 내가 가진 역할의 정의를 고칠 수 없어요(자기 권한 올리기 금지).",
  "admin.rules.3": "내가 가진 권한(키·범위·팀) 안에서만 줄 수 있어요.",
  "admin.rules.4": "나보다 권한이 많은 사람의 역할은 관리할 수 없어요.",
  "admin.rules.5": "마지막 관리자는 내리거나 정지할 수 없어요.",
  "admin.rules.6": "글·실명·내보내기 권한이 늘어나면 2인 승인이 필요하고, 안내문 ‘누가 볼 수 있나요’가 바뀌어요.",
  "admin.rules.7": "바꾸면 대상자의 로그인이 다시 시작돼요.",
  "admin.dual.title": "2인 승인이 필요해요",
  "admin.dual.kicker": "글·실명·내보내기 권한이 늘어나요",
  "admin.dual.what": "바꾸려는 것",
  "admin.dual.p1": "요청한 사람과 승인하는 사람은 달라야 해요. 2인 승인 권한이 있는 원문 열람 담당이나 다른 관리자가 승인해요.",
  "admin.dual.p2": "승인되면 안내문 ‘누가 볼 수 있나요’가 함께 바뀌어 새 버전 초안이 생겨요.",
  "admin.dual.p3": "적용되면 대상자는 다시 로그인하게 돼요.",
  "admin.dual.reason": "요청 사유(10자 이상)",
  "admin.dual.reasonPh": "예: 장애 대응 동안 팀원 질문 글 확인이 필요해요(2주)",
  "admin.dual.send": "승인 요청 보내기",
  "admin.dual.sent": "승인 요청을 보냈어요({id}). 승인 대기 탭에서 볼 수 있어요.",
  "admin.roleDlg.kicker": "사용자 정의 역할",
  "admin.roleDlg.copyTitle": "역할 복사",
  "admin.roleDlg.newTitle": "새 역할 만들기",
  "admin.roleDlg.base": "기반 역할",
  "admin.roleDlg.name": "이름",
  "admin.roleDlg.namePh": "예: 보안 조사 담당",
  "admin.roleDlg.desc": "설명(선택)",
  "admin.roleDlg.hint": "새 역할은 기반 역할의 권한을 그대로 복사해요. 만든 뒤 권한 표에서 칸을 바꿔 고치세요. 아무에게도 주지 않았으니 지금은 아무도 더 보지 않아요.",
  "admin.roleDlg.basePerms": "기반 역할의 묶음별 범위",
  "admin.roleDlg.create": "만들기",
  "admin.roleDlg.errName": "이름을 2~20자로 적어 주세요.",
  "admin.roleDlg.errDup": "같은 이름의 역할이 있어요.",
  "admin.roleDlg.created": "‘{name}’ 역할을 만들었어요",
  "admin.preview.kicker": "이 역할로 보이는 화면",
  "admin.preview.title": "{role} 미리 보기",
  "admin.preview.kind": "종류",
  "admin.preview.holders": "가진 사람",
  "admin.preview.scopes": "보기 범위 선택지",
  "admin.preview.checks": "로그인 조건",
  "admin.preview.checksNone": "추가 조건 없음",
  "admin.preview.menus": "보이는 메뉴 {n}개",
  "admin.preview.bundles": "묶음별 가장 넓은 범위",
  "admin.preview.lock": "남의 글을 열면 이렇게 보여요",
  "admin.preview.lockFlow": "사유 입력 → 다시 로그인 확인 → 대화 단위 허가를 거쳐 열어요. 열람은 당사자에게 표시돼요.",
  "admin.preview.lockNone": "이 역할은 남의 질문·답변 글을 열 수 없어요.",
  "admin.preview.switch": "이 역할로 바꿔 보기",
  "admin.preview.switchNote": "목업 전용이에요. 사용자 메뉴 › 역할 바꿔 보기에서 다시 돌아올 수 있어요.",
  "admin.preview.custom": "사용자 정의 역할은 목업에서 바꿔 볼 수 없어요. 위 메뉴와 범위로 확인하세요.",
  "admin.preview.current": "지금 보고 있는 역할이에요.",
  "admin.grant.q": "누구에게 어떤 역할을 줄까요?",
  "admin.grant.tech": "사람 찾기 → 역할 · 적용 팀 · 만료일 · 사유",
  "admin.grant.sum": "{scope} 안의 {n}명에게 역할을 줄 수 있어요.",
  "admin.grant.s1": "사람",
  "admin.grant.s2": "역할",
  "admin.grant.s3": "적용 팀",
  "admin.grant.s3m": "매니저가 맡을 팀",
  "admin.grant.s4": "만료일",
  "admin.grant.s5": "사유",
  "admin.grant.search": "이름·팀으로 찾기",
  "admin.grant.pickLabel": "역할을 줄 사람",
  "admin.grant.noMatch": "찾는 사람이 없어요.",
  "admin.grant.self": "나에게는 줄 수 없어요",
  "admin.grant.more": "나보다 권한이 많아요",
  "admin.grant.rolePh": "역할 고르기",
  "admin.grant.roleExceeds": "내 권한보다 넓어요",
  "admin.grant.roleHas": "이미 가졌어요",
  "admin.grant.teamHint": "‘팀’ 범위 권한은 여기서 고른 팀에만 닿아요.",
  "admin.grant.noTeam": "이 역할에는 팀 범위 권한이 없어요.",
  "admin.grant.required": "필수",
  "admin.grant.expHint": "질문·답변 글이나 작업 상세를 팀·전체로 보는 역할은 만료일이 꼭 있어야 해요.",
  "admin.grant.expOptional": "비워 두면 만료 없이 줘요. 90일 동안 쓰지 않으면 알려 드려요.",
  "admin.grant.reasonPh": "예: 데이터팀 매니저로 지정",
  "admin.grant.effect": "이렇게 바뀌어요",
  "admin.grant.effectPick": "사람과 역할을 고르면 새로 생기는 권한이 보여요.",
  "admin.grant.effectNone": "이미 가진 권한과 같아 새로 생기는 권한은 없어요.",
  "admin.grant.effectNew": "새로 생기는 권한 {n}개",
  "admin.grant.effectDual": "2인 승인을 거쳐야 적용돼요.",
  "admin.grant.effectRelogin": "대상자는 다시 로그인하게 돼요.",
  "admin.grant.submit": "역할 주기",
  "admin.grant.submitDual": "승인 요청 보내기",
  "admin.grant.reset": "처음부터",
  "admin.grant.errPerson": "역할을 줄 사람을 고르세요.",
  "admin.grant.errRole": "역할을 고르세요.",
  "admin.grant.errTeam": "적용 팀을 하나 이상 고르세요.",
  "admin.grant.errExp": "이 역할은 만료일이 꼭 필요해요(내일 이후).",
  "admin.grant.errDate": "만료일은 내일 이후로 고르세요.",
  "admin.grant.errReason": "사유를 5자 이상 적어 주세요.",
  "admin.grant.errDup": "같은 역할·같은 팀 부여가 이미 있어요.",
  "admin.grant.done": "{who}에게 ‘{role}’ 역할을 줬어요",
  "admin.grant.pcOnly": "역할 주기는 PC에서 해 주세요. 휴대폰에서는 누가 어떤 역할을 가졌는지만 봐요.",
  "admin.grants.q": "누가 어떤 역할을 가졌나요?",
  "admin.grants.tech": "역할 부여 · 적용 팀 · 만료 · 부여·승인한 사람",
  "admin.grants.sum": "부여 {n}건 중 {e}건에 만료일이 있어요.",
  "admin.grants.member": "모든 사람은 일반 사용자 역할을 함께 가져요. 이 역할은 거둘 수 없고 계정 정지로 대신해요.",
  "admin.grants.col.person": "사람",
  "admin.grants.col.role": "역할",
  "admin.grants.col.teams": "적용 팀",
  "admin.grants.col.expires": "만료",
  "admin.grants.col.granted": "부여",
  "admin.grants.col.approved": "승인",
  "admin.grants.col.act": "관리",
  "admin.grants.allScope": "회사 전체",
  "admin.grants.needExpiry": "만료일을 정해 주세요",
  "admin.grants.soon": "{n}일 뒤 만료",
  "admin.grants.search": "사람·역할 찾기",
  "admin.grants.empty": "조건에 맞는 부여가 없어요.",
  "admin.grants.revoke": "거두기",
  "admin.grants.revokeTitle": "이 역할을 거둘까요?",
  "admin.grants.revokeBody": "{who}의 ‘{role}’ 역할을 거둬요. 대상자는 다시 로그인하게 되고, 이력에 남아요.",
  "admin.grants.revoked": "{who}의 ‘{role}’ 역할을 거뒀어요",
  "admin.grants.lastAdmin": "마지막 관리자는 내릴 수 없어요",
  "admin.grants.selfNo": "내 역할은 내가 거둘 수 없어요",
  "admin.grants.moreNo": "나보다 권한이 많은 사람이에요",
  "admin.apr.q": "승인을 기다리는 요청이 있나요?",
  "admin.apr.tech": "2인 승인 · 요청 → 승인 → 적용",
  "admin.apr.sum": "{n}건이 승인을 기다려요.",
  "admin.apr.sumNone": "기다리는 요청이 없어요.",
  "admin.apr.emptyNot": "글·실명·내보내기 권한이 늘어나는 변경만 여기에 와요.",
  "admin.apr.target": "{who}에게 ‘{perm}’({scope}) 주기",
  "admin.apr.viaRole": "{role} 역할",
  "admin.apr.targetRole": "{role} 역할의 ‘{perm}’ {from} → {to}",
  "admin.apr.targetCase": "조사 건 {id} 시작 · 대상 {n}명",
  "admin.apr.targetGrant": "{who}에게 ‘{role}’ 역할 주기",
  "admin.apr.targetReplace": "{who}의 역할을 ‘{role}’로 바꾸기",
  "admin.apr.replaceHint": "승인하면 일반 사용자 역할은 유지하고, 나머지 기존 역할을 모두 회수한 뒤 선택한 역할을 적용해요.",
  "admin.apr.meta": "{id} · 요청 {req} · {date} · {until}까지",
  "admin.apr.sign": "승인 단계",
  "admin.apr.step.req": "요청",
  "admin.apr.step.ok": "승인",
  "admin.apr.step.apply": "적용",
  "admin.apr.approverHint": "원문 열람 담당 또는 다른 관리자",
  "admin.apr.applyHint": "대상자 다시 로그인",
  "admin.apr.applied": "적용됨",
  "admin.apr.notice": "안내문 바뀜",
  "admin.apr.approve": "승인",
  "admin.apr.reject": "거절",
  "admin.apr.withdraw": "요청 거두기",
  "admin.apr.selfNo": "요청한 사람은 승인할 수 없어요(요청자 ≠ 승인자)",
  "admin.apr.sole": "승인할 수 있는 사람이 요청자뿐이라 직접 승인할 수 있어요. 이력에 ‘단독 승인’으로 남고, 승인할 관리자가 한 명 더 생기면 2인 승인으로 돌아가요.",
  "admin.apr.noPerm": "2인 승인 권한이 있는 사람이 승인해요",
  "admin.apr.tryReviewer": "원문 열람 담당으로 바꿔 승인해 보기",
  "admin.apr.tryNote": "홈의 ‘처리할 열람 일이 있나요?’ 카드에서 승인할 수 있어요. 승인되면 이 화면에서 바로 적용돼요.",
  "admin.apr.approveTitle": "이 요청을 승인할까요?",
  "admin.apr.approveBody": "승인하면 바로 적용되고, 대상자는 다시 로그인하게 돼요. 승인도 이력에 남아요.",
  "admin.apr.rejectTitle": "이 요청을 거절할까요?",
  "admin.apr.rejectReason": "거절 사유(5자 이상)",
  "admin.apr.memo": "메모(선택)",
  "admin.apr.approved": "승인했어요. 적용했고 이력에 남았어요.",
  "admin.apr.rejected": "거절했어요. 이력에 남았어요.",
  "admin.apr.withdrawn": "요청을 거뒀어요. 이력에 남았어요.",
  "admin.apr.status.pending": "승인 대기",
  "admin.apr.status.approved": "승인됨",
  "admin.apr.status.rejected": "거절됨",
  "admin.apr.status.withdrawn": "거둠",
  "admin.case.q": "진행 중인 조사 건이 있나요?",
  "admin.case.tech": "여러 사람의 글을 보는 조사 · 대상 · 기간 · 2인 승인",
  "admin.case.sum": "조사 건 {n}건 중 {a}건이 진행 중이에요.",
  "admin.case.sumNone": "조사 건이 없어요.",
  "admin.case.emptyNot": "여러 사람의 글을 반복해 여는 조사는 조사 건으로만 해요.",
  "admin.case.targets": "대상",
  "admin.case.period": "기간",
  "admin.case.views": "열람 {n}건",
  "admin.case.notify": "당사자 표시: 바로(통지 유예 없음)",
  "admin.case.notifyLabel": "당사자 표시",
  "admin.case.notifyNow": "바로 표시(통지 유예 없음)",
  "admin.case.status.pending": "승인 대기",
  "admin.case.status.approved": "진행 중",
  "admin.case.status.closed": "끝남",
  "admin.case.status.rejected": "거절됨",
  "admin.case.step.run": "진행",
  "admin.case.close": "끝내기",
  "admin.case.closeTitle": "조사 건을 끝낼까요?",
  "admin.case.closeBody": "끝내면 이 조사 건으로 받은 열람 허가가 모두 닫혀요. 끝낸 일도 이력에 남아요.",
  "admin.case.closed": "조사 건을 끝냈어요.",
  "admin.case.new": "새 조사 건",
  "admin.case.dlgTitle": "조사 건 만들기",
  "admin.case.title": "제목",
  "admin.case.titlePh": "예: 외부 전송 의심 건",
  "admin.case.pick": "대상 사람",
  "admin.case.from": "시작",
  "admin.case.to": "끝",
  "admin.case.desc": "설명(10자 이상)",
  "admin.case.dlgHint": "조사 건은 2인 승인이 있어야 시작해요. 조사 중에도 다시 로그인 확인·대화 단위 허가·이력·당사자 표시는 그대로예요.",
  "admin.case.errTitle": "제목을 2자 이상 적어 주세요.",
  "admin.case.errTargets": "대상을 한 명 이상 고르세요.",
  "admin.case.errPeriod": "기간을 바르게 고르세요(최대 30일).",
  "admin.case.created": "조사 건 {id}의 승인 요청을 보냈어요.",
  "admin.hist.q": "어떤 요청을 처리했나요?",
  "admin.hist.tech": "승인 · 거절 · 거둠 · 최근 순",
  "admin.hist.sum": "처리한 요청은 {n}건이에요.",
  "admin.hist.empty": "아직 처리한 요청이 없어요.",
  "admin.hist.emptyNot": "승인·거절하면 여기에 쌓여요.",
  "admin.sa.edit": "서비스 계정 수정",
  "admin.sa.updated": "‘{name}’ 서비스 계정을 수정했어요",
  "admin.sa.ownerSearch": "소유자 찾기",
  "admin.sa.tokenNeeded": "새 전용 토큰이 필요해요",
  "admin.sa.ownerBlocked": "새 소유자를 지정한 뒤 다시 켜세요",
  "admin.sa.updateNote": "소유자나 만료일을 바꾸면 기존 토큰은 폐기돼요. 정지된 계정은 다시 켜고 새 토큰을 발급하세요.",
  "admin.act.sa.update": "서비스 계정 수정",
  "admin.sa.q": "사람 아닌 계정은 무엇이 있나요?",
  "admin.sa.tech": "서비스 계정 · 소유자 · 용도 · 만료 · 전용 토큰",
  "admin.sa.sum": "서비스 계정 {n}개 중 가장 먼저 만료되는 건 {date}이에요.",
  "admin.sa.col.name": "이름",
  "admin.sa.col.purpose": "용도",
  "admin.sa.col.owner": "소유자",
  "admin.sa.col.expires": "만료",
  "admin.sa.col.token": "전용 토큰",
  "admin.sa.col.last": "마지막 사용",
  "admin.sa.col.status": "상태",
  "admin.sa.new": "서비스 계정 만들기",
  "admin.sa.reissue": "전용 토큰 다시 발급",
  "admin.sa.suspend": "정지",
  "admin.sa.resume": "다시 켜기",
  "admin.sa.status.active": "사용 중",
  "admin.sa.status.suspended": "정지됨",
  "admin.sa.note.1": "화면 로그인은 없어요. 전용 토큰으로 회사 게이트웨이만 불러요(조회 권한 없음).",
  "admin.sa.note.2": "사용량은 소유자에게 ‘앱 사용’으로 따로 보이고, 사용 방식은 API 키 호출로 세요.",
  "admin.sa.note.3": "사람이 아니라 동의 대상이 아니에요. 앱별 글 저장 정책(기본: 기본 정보만)을 따라요.",
  "admin.sa.note.4": "만료일은 꼭 있어야 해요. 소유자가 퇴사·정지되면 새 소유자를 정할 때까지 멈춰요.",
  "admin.sa.readonly": "서비스 계정을 만들고 고치는 일은 회사 전체 범위의 관리자만 해요.",
  "admin.sa.dlgTitle": "서비스 계정 만들기",
  "admin.sa.name": "이름(영문 소문자·숫자·하이픈)",
  "admin.sa.purpose": "용도",
  "admin.sa.purposePh": "예: 야간 품질 점검 배치",
  "admin.sa.owner": "소유자",
  "admin.sa.expires": "만료일(1년 안)",
  "admin.sa.create": "만들고 전용 토큰 받기",
  "admin.sa.errName": "이름은 영문 소문자·숫자·하이픈 3~32자로 적어 주세요.",
  "admin.sa.errDup": "같은 이름의 서비스 계정이 있어요.",
  "admin.sa.errPurpose": "용도를 적어 주세요.",
  "admin.sa.errExp": "만료일을 내일부터 1년 안으로 고르세요.",
  "admin.sa.tokenTitle": "전용 토큰은 지금 한 번만 보여요",
  "admin.sa.tokenBody": "복사해서 앱의 비밀 저장소에 넣으세요. 창을 닫으면 다시 볼 수 없어요. 목업 값이라 실제로는 쓸 수 없어요.",
  "admin.sa.created": "‘{name}’ 서비스 계정을 만들었어요",
  "admin.sa.reissueTitle": "전용 토큰을 다시 발급할까요?",
  "admin.sa.reissueBody": "지금 전용 토큰은 바로 폐기돼요. 앱 설정을 새 전용 토큰으로 바꿔야 다시 불러요.",
  "admin.sa.reissued": "전용 토큰을 새로 발급하고 옛 것은 폐기했어요",
  "admin.sa.suspended": "‘{name}’을 정지했어요",
  "admin.sa.resumed": "‘{name}’을 다시 켰어요",
  "admin.sa.empty": "볼 수 있는 서비스 계정이 없어요.",
  "admin.sa.emptyNot": "사내 앱·CI가 게이트웨이를 부르려면 서비스 계정이 있어야 해요.",
  // SCR-11 roles & permissions — wording the API contract needs beyond the mockup (admin.rp.*)
  "admin.rp.pseudo": "사용자 #{code}",
  "admin.rp.system": "시스템",
  "admin.rp.unit.items": "개",
  "admin.rp.unit.days": "일",
  "admin.rp.unit.min": "분",
  "admin.rp.unit.people": "명",
  "admin.rp.err.generic": "처리하지 못했어요. 잠시 뒤 다시 시도해 주세요.",
  "admin.rp.err.forbidden": "이 일을 할 권한이 없어요. 필요하면 관리자에게 권한을 요청하세요.",
  "admin.rp.err.notFound": "대상을 찾을 수 없어요. 새로 불러와 다시 확인해 주세요.",
  "admin.rp.err.stale": "다른 사람이 먼저 바꿨어요. 새로 불러온 값을 확인하고 다시 저장해 주세요.",
  "admin.rp.err.network": "서버에 연결하지 못했어요. 연결을 확인하고 다시 시도해 주세요.",
  "admin.rp.err.validation": "입력한 값을 확인해 주세요.",
  "admin.rp.err.reauth": "다시 로그인 확인을 마쳐야 바꿀 수 있어요.",
  "admin.rp.err.mfa": "이 일을 하려면 다단계 인증(MFA)이 필요해요. 내 기록·동의 → 내 정보·알림·화면 → [MFA 등록]을 마친 뒤 다시 시도하세요.",
  "admin.rp.err.pledge": "이 일을 하려면 금지 용도 약정을 먼저 마쳐야 해요. 화면을 새로 고쳐 약정을 마친 뒤 다시 시도하세요.",
  "admin.rp.err.roleInUse": "가진 사람이나 승인 대기가 있어 지울 수 없어요.",
  "admin.rp.err.approvalPending": "이미 승인을 기다리는 요청이 있어요. 승인 대기 탭에서 먼저 처리하세요.",
  "admin.rp.err.noticeChanged": "그사이 초안이 바뀌었어요. 새로 불러온 초안을 확인하고 다시 게시해 주세요.",
  "admin.rp.err.processed": "이미 처리된 요청이에요.",
  "admin.rp.undoExpired": "되돌릴 수 있는 시간이 지났어요.",
  "admin.rp.saveFail": "저장하지 못했어요",
  "admin.rp.noticeDraft": "안내문 새 버전 초안이 생겼어요. 기록 정책 › 안내문에서 게시해 주세요.",
  "admin.rp.reauth.desc": "보안을 위해 비밀번호를 다시 확인해요. 확인하면 잠시 동안 다시 묻지 않아요.",
  "admin.rp.reauth.confirm": "확인하고 계속",
  "admin.rp.reauth.wrong": "비밀번호가 맞지 않아요. 다시 입력해 주세요.",
  "admin.rp.reauth.googleNote": "Google에서 다시 로그인한 뒤 같은 변경을 한 번 더 해 주세요.",
  "admin.rp.roles.preview": "바뀌는 것",
  "admin.rp.roles.justChanged": "방금 바꿈",
  "admin.rp.roles.legendChanged": "방금 바꾼 칸(알림에서 되돌릴 수 있어요)",
  "admin.rp.roles.edit": "이름·설명 고치기",
  "admin.rp.roleDlg.editTitle": "역할 이름·설명 고치기",
  "admin.rp.roleDlg.save": "저장",
  "admin.rp.roleDlg.saved": "‘{name}’ 역할을 고쳤어요",
  "admin.rp.grant.count": "{n}명 · 고를 수 있는 사람 {m}명",
  "admin.rp.grant.scope": "내 범위 밖이에요",
  "admin.rp.grants.scopeNo": "내 범위 밖이라 거둘 수 없어요",
  "admin.rp.grants.teamsBtn": "맡을 팀",
  "admin.rp.grants.teamsTitle": "{who} · 매니저가 맡을 팀",
  "admin.rp.grants.teamsHint": "고른 팀의 매니저로 지정하고, 뺀 팀에서는 매니저를 거둬요. 추가 지정은 팀별로 독립 승인을 요청해요. 반영된 변경과 승인 대기를 각각 알려드려요.",
  "admin.rp.grants.teamsSaved": "맡을 팀을 바꿨어요",
  "admin.rp.apr.approveReason": "승인 사유",
  "admin.rp.apr.expired": "기한 지남",
  "admin.rp.apr.targetDefer": "조사 건 {id}의 당사자 표시 미루기",
  "admin.rp.case.defer": "당사자 표시 미루기",
  "admin.rp.case.deferTitle": "당사자 표시를 미룰까요?",
  "admin.rp.case.deferUntil": "언제까지",
  "admin.rp.case.deferReason": "사유(10자 이상)",
  "admin.rp.case.deferHint": "조사를 방해할 우려가 있을 때만 써요. 2인 승인이 있어야 미뤄지고, 최대 {n}일까지예요. 기한이 지나면 자동으로 표시돼요.",
  "admin.rp.case.deferErrDate": "내일부터 {n}일 안의 날짜를 고르세요.",
  "admin.rp.case.deferSent": "당사자 표시 미루기 승인 요청을 보냈어요({id}).",
  "admin.rp.case.notifyUntil": "{date}까지 미룸",
  "admin.rp.sa.tokenOnce": "복사해서 앱의 비밀 저장소에 넣으세요. 창을 닫으면 다시 볼 수 없어요.",
  "admin.rp.sa.expired": "만료됨",
  "admin.rp.review.q": "글·실명·내보내기 권한을 계속 줄까요?",
  "admin.rp.review.tech": "분기 재검토 · {quarter} · 90일 동안 안 쓴 권한 표시",
  "admin.rp.review.sum": "검토할 부여가 {n}건이고, 그중 {d}건은 90일 동안 쓰지 않았어요.",
  "admin.rp.review.sumDone": "이번 분기 재검토를 {date}에 남겼어요. 바뀐 게 있으면 다시 남길 수 있어요.",
  "admin.rp.review.col.keys": "권한",
  "admin.rp.review.col.last": "마지막 사용",
  "admin.rp.review.col.decision": "결정",
  "admin.rp.review.keep": "유지",
  "admin.rp.review.revoke": "회수",
  "admin.rp.review.dormant": "90일 동안 안 씀",
  "admin.rp.review.never": "쓴 적 없음",
  "admin.rp.review.note": "메모(선택)",
  "admin.rp.review.submit": "재검토 결과 남기기",
  "admin.rp.review.confirmTitle": "재검토 결과를 남길까요?",
  "admin.rp.review.confirmBody": "유지 {k}건 · 회수 {r}건이에요. 회수하면 대상자는 다시 로그인하게 되고, 결과는 이력에 남아요.",
  "admin.rp.review.done": "재검토 결과를 남겼어요.",
  "admin.rp.review.empty": "검토할 권한이 없어요.",
  "admin.rp.review.emptyNot": "글·실명·내보내기 권한을 준 부여가 생기면 여기에 보여요.",
  "admin.pol.desc": "정책 버전 {v} · {date} {who} 저장 · 안내문 {nv}",
  "admin.pol.tabs": "기록 정책 보기",
  "admin.pol.tab.ceiling": "기록 수준 상한",
  "admin.pol.tab.notice": "안내문",
  "admin.pol.tab.redaction": "가림 규칙",
  "admin.pol.tab.retention": "보관 기간",
  "admin.pol.tab.access": "열람 통제·보호",
  "admin.pol.tab.deletion": "삭제·법적 보관",
  "admin.pol.kpi.cap": "회사 기록 수준 상한",
  "admin.pol.kpi.capHint": "실제로 남는 것 = 상한 ∩ 본인 선택",
  "admin.pol.kpi.capCustom": "직접 고름",
  "admin.pol.kpi.notice": "안내문",
  "admin.pol.kpi.noticeHint": "다시 동의 기다림 {n}명",
  "admin.pol.kpi.content": "질문·답변 글 보관",
  "admin.pol.kpi.contentHint": "{min}~{max}일에서 골라요",
  "admin.pol.kpi.grant": "글 열람 허가",
  "admin.pol.kpi.grantHint": "끌 수 없어요 · 대화 하나 단위",
  "admin.pol.dirty": "저장하지 않은 변경 {n}개",
  "admin.pol.revert": "되돌리기",
  "admin.pol.save": "저장",
  "admin.pol.noChange": "바꾼 값이 없어요",
  "admin.pol.saveTitle": "정책을 저장할까요?",
  "admin.pol.saveKicker": "정책 버전 {v} → {v2}",
  "admin.pol.saveList": "바뀌는 것",
  "admin.pol.saveNotice": "안내문 {secs}절이 바뀌어 새 버전 초안({ver})이 생겨요. 게시하면 모든 사용자에게 다시 동의를 받아요.",
  "admin.pol.saveReason": "바꾸는 까닭(선택)",
  "admin.pol.saveLog": "저장하면 바뀐 값마다 열람·변경 이력에 남아요.",
  "admin.pol.saved": "정책을 저장했어요(버전 {v}).",
  "admin.cap.q": "회사는 어디까지 남기게 하나요?",
  "admin.cap.tech": "회사 기록 수준 상한 · 항목별 스위치 6개 + 4단계 프리셋",
  "admin.cap.sum": "상한은 {level}이고, {n}명 모두 상한 안에서 골랐어요.",
  "admin.cap.sumCut": "상한이 {level}이면 {n}명의 기록 수준이 상한에 맞춰 낮아져요.",
  "admin.cap.presets": "4단계 프리셋",
  "admin.cap.items": "항목별 상한",
  "admin.cap.custom": "항목을 따로 골라 프리셋과 달라요(직접 고름).",
  "admin.cap.basicLock": "기본 정보는 끌 수 없어요(회사 키 이용 조건 · 필수 처리).",
  "admin.cap.toolWarn": "도구 결과에는 파일 내용·명령 출력 일부가 들어가요. 가림이 완벽하지 않으니 꼭 필요할 때만 켜세요.",
  "admin.cap.helperOff": "PC 도우미(선택 모듈)가 꺼져 있어 고를 수 없어요.",
  "admin.cap.item.basic": "시각·도구·AI 모델·사용량·시간·성공 여부",
  "admin.cap.item.prompt": "내가 보낸 질문 글",
  "admin.cap.item.answer": "AI 답변 글(Codex는 비공식 설정)",
  "admin.cap.item.work_detail": "명령·파일 경로·바뀐 내용",
  "admin.cap.item.tool_output": "파일 내용·명령 출력 일부(직접 고르기에서만)",
  "admin.cap.item.server_upload": "PC 도우미가 모은 기록을 회사 서버로 보내기",
  "admin.cap.dist": "사람들이 고른 기록 수준",
  "admin.cap.distCut": "{n}명이 상한에 맞춰 낮아져요",
  "admin.cap.rule": "실제로 남는 것은 회사 상한과 본인 선택이 겹치는 부분이에요. 상한을 낮추면 바로 적용되고, 다시 올리면 본인이 고른 수준으로 돌아가요.",
  "admin.cap.notice": "상한이 바뀌면 안내문 2절(항목)이 바뀌어요.",
  "admin.notice.q": "안내문은 지금 설정과 맞나요?",
  "admin.notice.tech": "안내문 {v} · 필수 절 10개 · 5개 절은 설정에서 자동으로 채워요",
  "admin.notice.sumSame": "게시한 {v}와 지금 설정이 같아요. 다시 동의를 기다리는 사람은 {n}명이에요.",
  "admin.notice.sumDiff": "안내문과 실제 설정이 달라요. {secs}절이 바뀌어 새 버전 {ver}을 게시해야 해요.",
  "admin.notice.diffTitle": "안내문과 실제 설정이 달라요",
  "admin.notice.diffDesc": "바뀐 절을 확인하고 새 버전을 게시하세요. 게시 전까지 사람들은 옛 안내문을 봐요.",
  "admin.notice.publish": "새 버전 게시",
  "admin.notice.publishNo": "바뀐 설정이 없어 새 버전이 필요 없어요",
  "admin.notice.pubTitle": "{ver}을 게시할까요?",
  "admin.notice.pubBody": "게시하면 모든 사용자에게 다시 동의를 받아요. 다시 동의하기 전 기록은 저장하지 않고 건수만 남겨요. 게시 시각을 미리 알려 주세요.",
  "admin.notice.published": "{ver}을 게시했어요. 모든 사용자에게 다시 동의를 요청했어요.",
  "admin.notice.auto": "자동: {src}",
  "admin.notice.autoRo": "설정에서 자동으로 채워서 여기서는 고칠 수 없어요",
  "admin.notice.changed": "바뀜",
  "admin.notice.edited": "고친 초안",
  "admin.notice.editedTitle": "게시하지 않은 고친 글이 있어요",
  "admin.notice.editedDesc": "미리보기로 확인한 뒤 새 버전을 게시하세요. 게시하기 전까지 사람들은 지금 안내문을 봐요.",
  "admin.notice.sumEdit": "고친 {secs}절을 아직 게시하지 않았어요. 새 버전 {ver}을 게시하면 모두에게 다시 동의를 받아요.",
  "admin.notice.pcOnly": "안내문 글은 PC에서 고쳐요. 여기서는 지금 내용만 볼 수 있어요.",
  "admin.ned.edit": "고치기",
  "admin.ned.editAria": "{sec} 고치기",
  "admin.ned.kicker": "안내문 초안 · {ver}",
  "admin.ned.tabs": "안내문 편집 단계",
  "admin.ned.tab.edit": "고치기",
  "admin.ned.tab.preview": "미리보기",
  "admin.ned.label": "{sec} 글",
  "admin.ned.hint": "굵게는 **글**처럼 쓰고, 목록은 줄 앞에 - 를 붙여요. HTML은 넣을 수 없어요.",
  "admin.ned.lang": "지금은 한국어 안내문을 고쳐요. 영어 안내문은 화면 언어를 바꿔 따로 고쳐요.",
  "admin.ned.preview": "동의할 때 보는 안내문에서 이렇게 보여요.",
  "admin.ned.save": "초안에 넣기",
  "admin.ned.reset": "게시한 글로 되돌리기",
  "admin.ned.errEmpty": "글을 비울 수 없어요.",
  "admin.ned.errHtml": "HTML 태그는 넣을 수 없어요. 굵게(**)와 목록(-)만 써요.",
  "admin.ned.saved": "{sec}{eul} 초안에 넣었어요. 새 버전을 게시해야 사람들에게 보여요.",
  "admin.ned.same": "게시한 글과 같아서 초안에서 뺐어요.",
  "admin.notice.src.caps": "회사 상한",
  "admin.notice.src.retention": "보관 기간 표",
  "admin.notice.src.roles": "권한 표",
  "admin.notice.src.redaction": "가림 규칙표",
  "admin.notice.src.integrations": "연동 설정",
  "admin.notice.versions.q": "어떤 버전을 게시했나요?",
  "admin.notice.versions.tech": "안내문 버전 · 본문 해시 · 다시 동의",
  "admin.notice.versions.sum": "지금 버전은 {v}({date} 게시)예요.",
  "admin.notice.current": "지금 버전",
  "admin.notice.col.ver": "버전",
  "admin.notice.col.at": "게시",
  "admin.notice.col.hash": "본문 해시",
  "admin.notice.col.changes": "바뀐 점",
  "admin.notice.first": "첫 게시",
  "admin.notice.changesAuto": "{secs}절을 바꿨어요.",
  "admin.ns.1": "1. 목적",
  "admin.ns.2": "2. 항목",
  "admin.ns.3": "3. 기록하지 않는 것",
  "admin.ns.4": "4. 보유 기간",
  "admin.ns.5": "5. 볼 수 있는 역할",
  "admin.ns.6": "6. 거부권과 결과",
  "admin.ns.7": "7. 가림 한계",
  "admin.ns.8": "8. 국외 AI 회사 전달",
  "admin.ns.9": "9. 권리 행사 방법",
  "admin.ns.10": "10. 개인정보 보호책임자·문의처",
  "admin.ns.1.body": "AI 사용량·비용을 관리하고 보안 사고를 조사하려고 기록해요. 근무 시간·성과 평가나 감시에는 쓰지 않아요.",
  "admin.ns.2.req": "필수 처리: 기본 정보(회사 키 이용 조건)",
  "admin.ns.2.opt": "선택 동의: {items}",
  "admin.ns.2.off": "회사 상한에서 꺼짐: {items}",
  "admin.ns.3.body": "AI의 중간 생각, 요청 본문 전체(원문 모드 제외), 키 입력·화면·네트워크 전체는 남기지 않아요.",
  "admin.ns.4.backup": "백업에는 최대 30일 남아요.",
  "admin.ns.5.content": "질문·답변 글: {roles} — 사유·다시 로그인 확인·대화 단위 허가를 거쳐요",
  "admin.ns.5.identity": "실명: {roles}",
  "admin.ns.5.individual": "개인별 상세: {roles} — 열 때마다 이력이 남고 당사자에게 표시돼요",
  "admin.ns.5.none": "없음",
  "admin.ns.6.body": "거부하거나 철회해도 CLI 도구는 그대로 쓸 수 있어요. 회사 키 게이트웨이는 쓸 수 없어요.",
  "admin.ns.7.body": "가림은 정해진 형식만 찾으므로 완벽하지 않아요. 지금 규칙 {n}개: {rules}",
  "admin.ns.8.on": "회사 게이트웨이로 부르면 요청이 국외 AI 회사(Anthropic·OpenAI)로 전달돼요.",
  "admin.ns.8.off": "회사 게이트웨이를 쓰지 않아 국외로 전달하는 요청이 없어요.",
  "admin.ns.9.body": "‘내 기록·동의’ 화면에서 열람·사본·삭제 요청·잠시 멈추기·철회를 할 수 있어요. 삭제 요청은 7일 안에 처리해요.",
  "admin.ns.10.body": "개인정보 보호책임자 {name}({title}) · privacy@example.com",
  "admin.red.q": "글 속 비밀값·개인정보는 어떻게 가리나요?",
  "admin.red.tech": "가림 규칙표 · 저장 직전 · 처리 방식 3가지(지움·일관 토큰·표식)",
  "admin.red.sum": "규칙 {n}개가 모두 켜져 있어요. 주민등록번호는 복원할 수 없게 지워요.",
  "admin.red.col.rule": "분류",
  "admin.red.col.finds": "찾는 것(예)",
  "admin.red.col.method": "처리 방식",
  "admin.red.col.fields": "적용 칸",
  "admin.red.m.delete": "지움(복원 불가)",
  "admin.red.m.consistent": "일관 토큰(대화 단위)",
  "admin.red.m.marker": "표식",
  "admin.red.m.omit": "생략 표식",
  "admin.red.m.nostore": "내용 저장 안 함",
  "admin.red.ms.consistent": "일관 토큰",
  "admin.red.ms.marker": "표식",
  "admin.red.fixed": "고정",
  "admin.red.r.secret": "비밀키·인증 토큰",
  "admin.red.r.secret.ex": "개인키 블록, JWT, Authorization 값, AI 회사·클라우드·Git 토큰 접두사, 이 시스템의 연결 토큰 접두사",
  "admin.red.r.assign": "비밀값 할당",
  "admin.red.r.assign.ex": "password=·secret=·api_key= 같은 할당(8자 이상), DB 접속 문자열의 비밀번호",
  "admin.red.r.rrn": "주민·외국인등록번호",
  "admin.red.r.rrn.ex": "체크섬이 맞는 번호",
  "admin.red.r.contact": "연락처",
  "admin.red.r.contact.ex": "휴대전화·유선전화, 이메일",
  "admin.red.r.finance": "카드·계좌",
  "admin.red.r.finance.ex": "카드번호(Luhn 검사), 계좌번호",
  "admin.red.r.blob": "긴 덩어리",
  "admin.red.r.blob.ex": "긴 base64, data URI",
  "admin.red.r.paths": "비밀 파일 경로",
  "admin.red.fields.text": "질문·답변·도구 인자·도구 결과·오류 메시지·목록 제목",
  "admin.red.fields.paths": "도구 입력·출력, 파일 목록",
  "admin.red.methodNote": "연락처·카드를 일관 토큰으로 둘지 표식으로 둘지는 개인정보 담당과 확인해 정해요.",
  "admin.red.order": "처리 순서: 연결 토큰 확인 → 허용 목록 → 동의 게이트 → 비밀 파일 경로 → 가림 → 길이 상한 → 암호화 → 중복 제거",
  "admin.red.limit": "가림은 정해진 형식만 찾으므로 완벽하지 않아요.",
  "admin.red.paths": "이 경로가 보이면 기록 수준과 상관없이 내용을 저장하지 않고 건수만 남겨요",
  "admin.red.pv.q": "미리보기: 이 글은 이렇게 저장돼요",
  "admin.red.pv.label": "시험해 볼 글(가짜 값으로 시험하세요)",
  "admin.red.pv.sample": "배포 키는 sk-ant-demo-7f3a9c21e4b0 이에요. 담당자 메일은 dev.lead@example.com, 전화는 010-0000-1234예요. 확인되면 dev.lead@example.com로 다시 알려 주세요.", // secret-scan:allow — 가림 미리보기용 가짜 키(demo)
  "admin.red.pv.out": "저장되는 모습",
  "admin.red.pv.count": "가린 곳 {n}군데",
  "admin.red.pv.none": "가릴 것을 찾지 못했어요.",
  "admin.red.del": "지움",
  "admin.red.omitTag": "생략",
  "admin.ret.q": "기록을 얼마나 오래 두나요?",
  "admin.ret.tech": "대상별 기본·하한·상한 · 하한 아래는 고를 수 없어요",
  "admin.ret.sum": "질문·답변 글은 {c}, 사용량·기본 정보는 {u} 뒤에 지워요.",
  "admin.ret.col.target": "대상",
  "admin.ret.col.value": "지금 값",
  "admin.ret.col.def": "기본",
  "admin.ret.col.range": "하한~상한",
  "admin.ret.col.after": "기간이 지나면",
  "admin.ret.fixed": "고정",
  "admin.ret.upto": "{v} 이하",
  "admin.ret.atLeast": "{v} 이상",
  "admin.ret.belowMin": "하한보다 짧아 고를 수 없어요",
  "admin.ret.notice": "보관 기간이 바뀌면 안내문 4절(보유 기간)이 바뀌어요.",
  "admin.ret.t.content": "질문·답변 글·작업 상세",
  "admin.ret.t.raw_gateway": "요청 본문 저장(원문 모드)·게이트웨이 글",
  "admin.ret.t.usage": "사용량·기본 정보",
  "admin.ret.t.aggregate": "비식별 집계(팀 단위)",
  "admin.ret.t.consent": "동의 이력·안내문 버전",
  "admin.ret.t.audit_permission": "열람·변경 이력: 권한·역할 변경",
  "admin.ret.t.audit_access": "열람·변경 이력: 접속기록",
  "admin.ret.t.audit_general": "열람·변경 이력: 일반 운영",
  "admin.ret.t.backup": "DB 백업",
  "admin.ret.a.content": "글을 지우고 ‘기록 없음 · 보관 기간 지나 삭제’로 보여요",
  "admin.ret.a.deleted": "지워요",
  "admin.ret.a.usage": "지워요. 그 뒤에는 비식별 집계만 남아요",
  "admin.ret.a.consent": "관련 데이터 보관 기간 + 분쟁 대비 기간",
  "admin.ret.a.audit": "체크포인트를 남기고 지워요",
  "admin.ret.a.backup": "지워요. 안내문에 “백업에는 최대 30일 남아요”를 적어요",
  "admin.job.q": "보관 정리 작업은 잘 돌고 있나요?",
  "admin.job.tech": "매일 한 번 · 수신을 막지 않게 1,000행씩 · 법적 보관은 건너뛰어요",
  "admin.job.sum": "마지막 실행은 {rel}이에요.",
  "admin.job.sumNone": "아직 실행한 기록이 없어요.",
  "admin.job.run": "지금 실행",
  "admin.job.ran": "보관 정리를 실행했어요. 새로 지울 기록은 없었어요(0건).",
  "admin.job.ranDetail": "지금 실행 · 새로 지울 글 0건",
  "admin.job.noPerm": "보관 작업 관리 권한이 있어야 해요",
  "admin.acc.q": "남의 글을 열 때 무엇을 거치나요?",
  "admin.acc.tech": "글 열람 고정 통제 흐름 · 7단계 · 끌 수 없음",
  "admin.acc.sum": "허가는 대화 하나에 {m}분, 사유는 {c}자 이상, 다시 로그인 확인은 {r}분 동안 유효해요.",
  "admin.acc.noOff": "이 흐름에는 끄는 스위치가 없어요. 회사 정책으로도 끌 수 없고, 정해진 범위 안에서 값만 바꿔요.",
  "admin.acc.s1": "권한·약정·다단계 인증 확인",
  "admin.acc.s2": "사유 범주 + 설명",
  "admin.acc.s3": "다시 로그인 확인",
  "admin.acc.s4": "대화 단위 허가",
  "admin.acc.s5": "열람(워터마크·캐시 금지)",
  "admin.acc.s6": "성공·거부 모두 이력",
  "admin.acc.s7": "당사자 ‘누가 내 기록을 봤나요’ 표시",
  "admin.acc.fixed": "끌 수 없음",
  "admin.acc.value": "값만 조정",
  "admin.acc.v.grant": "허가 시간",
  "admin.acc.v.grantHint": "10~60분 · 기본 60분",
  "admin.acc.v.reason": "사유 최소 글자 수",
  "admin.acc.v.reasonHint": "10자보다 줄일 수 없어요",
  "admin.acc.v.reauth": "다시 로그인 확인 유효 시간",
  "admin.acc.v.reauthHint": "10분보다 늘릴 수 없어요",
  "admin.acc.cats": "사유 범주는 4가지로 고정이에요(평가·근태 범주 없음): {cats}",
  "admin.sg.q": "사람이 적은 조건도 보여 주나요?",
  "admin.sg.tech": "소집단 보호 하한 · 필터 뒤 남는 사람 수 기준",
  "admin.sg.sum": "{n}명보다 적으면 가려요. 지금은 {teams}{ga} 해당돼요.",
  "admin.sg.sumNone": "{n}명보다 적으면 가려요. 지금 해당하는 팀은 없어요.",
  "admin.sg.off": "1명만 사용해도 보여요. 인원수로 값을 가리지 않아요.",
  "admin.sg.value": "하한",
  "admin.sg.unit": "명",
  "admin.sg.fixed": "서버 설정에서 바꿔요. 1이면 인원수로 가리지 않고, 2 이상이면 기준보다 적은 인원의 값을 가려요.",
  "admin.sg.fixedBadge": "설정 파일로 고정됨",
  "admin.sg.where": "적용: 홈 카드 · 시간대 히트맵 · 사용 통계 · 사람·팀 비교 · 내보내기. 조회 권한과 기록 없음 표시는 계속 적용돼요.",
  "admin.vs.q": "사람을 값순으로 줄 세워도 되나요?",
  "admin.vs.tech": "사람 값순 정렬 허용 · 기본 끔",
  "admin.vs.sumOff": "꺼져 있어요. 사람 비교는 이름순으로만 보여요.",
  "admin.vs.sumOn": "켜져 있어요. 사용량·비용 지표만 값순으로 정렬할 수 있어요.",
  "admin.vs.switch": "사람 값순 정렬 허용",
  "admin.vs.desc": "켜도 AI 사용 시간·대화 길이·줄 수 지표는 순위를 만들지 않아요.",
  "admin.del.q": "삭제 요청은 어떻게 처리했나요?",
  "admin.del.tech": "요청 즉시 조회 차단 · 7일 안에 처리 · 법적 보관이 먼저",
  "admin.del.sum": "기다리는 삭제 요청은 없어요. 지금까지 {n}건을 처리했어요.",
  "admin.del.sumWait": "처리를 기다리는 삭제 요청이 {n}건 있어요.",
  "admin.del.emptyWhat": "삭제 요청이 없어요.",
  "admin.del.emptyNot": "요청이 오면 바로 조회가 막히고 여기에서 처리해요.",
  "admin.del.col.req": "요청",
  "admin.del.col.who": "요청한 사람",
  "admin.del.col.done": "처리",
  "admin.del.col.state": "결과",
  "admin.del.done": "삭제함",
  "admin.del.wait": "처리 대기",
  "admin.del.rule": "지우는 것은 글과 식별자예요. 비용 정산용 사용량은 가명·집계로 남겨요. 앱 자체 기록과 열람·변경 이력은 본인 삭제 대상이 아니에요.",
  "admin.lh.q": "법적 보관 중인 기록이 있나요?",
  "admin.lh.tech": "보관 정리·삭제 요청에서 빠져요 · 지정·해제는 당사자에게 표시",
  "admin.lh.sum": "{n}명의 기록을 법적 보관 중이에요.",
  "admin.lh.sumNone": "법적 보관 중인 기록이 없어요.",
  "admin.lh.emptyNot": "조사·분쟁에 필요한 기록만 사유와 함께 보관해요.",
  "admin.lh.until": "{date}까지",
  "admin.lh.since": "{date} 지정 · {who}",
  "admin.lh.release": "해제",
  "admin.lh.set": "법적 보관 지정",
  "admin.lh.releaseTitle": "법적 보관을 해제할까요?",
  "admin.lh.releaseBody": "해제하면 밀린 보관 정리·삭제 요청을 다시 처리해요. 해제도 당사자에게 표시돼요.",
  "admin.lh.reason": "사유(5자 이상)",
  "admin.lh.released": "법적 보관을 해제했어요.",
  "admin.lh.person": "사람",
  "admin.lh.untilLabel": "언제까지",
  "admin.lh.errUntil": "내일 이후 날짜를 고르세요.",
  "admin.lh.done": "법적 보관을 지정했어요.",
  "admin.lh.noPerm": "법적 보관 관리 권한이 있어야 해요",
  "admin.lh.released.tag": "해제됨",
  "admin.pol.hist.q": "최근에 정책을 어떻게 바꿨나요?",
  "admin.pol.hist.tech": "정책 변경 · 안내문 게시 · 최근 순",
  "admin.pol.hist.sum": "가장 최근 변경은 {rel}, {who}{ga} 했어요.",
  "admin.pol.hist.col.when": "시각",
  "admin.pol.hist.col.what": "무엇을",
  "admin.pol.hist.col.who": "누가",
  "admin.pol.hist.col.why": "까닭",
  // SCR-12 recording policy — wording the API contract needs beyond the mockup (admin.rp.*)
  "admin.rp.pol.descLimited": "이 화면에서는 맡은 일만 보여요. 다른 정책은 관리자가 정해요.",
  "admin.rp.red.busy": "가리는 중…",
  "admin.rp.redact.account": "계좌번호",
  "admin.rp.ret.aboveMax": "상한보다 길어 고를 수 없어요",
  "admin.rp.acc.defer": "조사 중 당사자 표시를 미룰 수 있는 최대 기간",
  "admin.rp.acc.bulk": "대량 열람 실시간 알림",
  "admin.rp.acc.bulkV": "조사 건 없이 1시간에 {n}건 넘게 열면",
  "admin.rp.acc.decided": "위 두 값은 회사가 정하는 값이라 여기서는 지금 값만 보여요.",
  "admin.rp.del.one": "대화 1건",
  "admin.rp.del.all": "전체",
  "admin.rp.del.stCanceled": "요청 취소",
  "admin.rp.del.due": "{n}일 안에 처리하지 않으면 자동으로 지워요.",
  "admin.rp.lh.notifyUntil": "당사자 표시 {date}까지 미룸",
  "admin.rp.lh.releasedBy": "{date} 해제 · {who}",
  "admin.rp.job.running": "보관 정리를 실행하는 중…",
  "admin.rp.job.progress": "보관 정리를 실행하는 중… {done}/{total}",
  "admin.rp.job.done": "보관 정리를 마쳤어요.",
  "admin.rp.job.failed": "보관 정리를 마치지 못했어요. 수집 상태에서 원인을 확인하세요.",
  "admin.rp.job.later": "보관 정리가 아직 진행 중이에요. 잠시 뒤 결과를 확인하세요.",
  "admin.rp.job.deleted": "{n}건 지움",
  "admin.rp.job.schedule": "매일 자동",
  "admin.rp.job.st.running": "실행 중",
  "admin.rp.job.st.ok": "마침",
  "admin.rp.job.st.partial": "일부만 마침",
  "admin.rp.job.st.error": "실패",
  "admin.rp.job.st.skipped": "건너뜀",
  "admin.aud.desc": "이력 {n}건 · 고치거나 지울 수 없어요 · 해시 체인과 외부 고정점으로 지켜요",
  "admin.aud.verify": "위변조 검사",
  "admin.aud.report": "월간 점검 보고서",
  "admin.aud.csv": "CSV 내보내기",
  "admin.aud.kpi.total": "이 기간 이력",
  "admin.aud.kpi.views": "글 열람",
  "admin.aud.kpi.viewsHint": "성공 {s} · 거부 {d}",
  "admin.aud.kpi.perm": "권한·정책 변경",
  "admin.aud.kpi.permHint": "권한 {p} · 정책 {q}",
  "admin.aud.kpi.integ": "위변조 검사",
  "admin.aud.kpi.ok": "정상",
  "admin.aud.kpi.bad": "끊김",
  "admin.aud.kpi.integHint": "이력 {n}건 · 고정점 {date}",
  "admin.aud.bulk": "{who}{ga} 1시간 안에 글을 {n}건 열었어요",
  "admin.aud.bulkCase": "조사 건 {id} 안의 열람이에요 · {from}~{to}",
  "admin.aud.bulkNoCase": "조사 건 없이 연 열람이에요. 사유를 확인하세요.",
  "admin.integ.q": "이력이 고쳐지지 않았나요?",
  "admin.integ.tech": "해시 체인 + 외부 고정점(매일 서명) 대조",
  "admin.integ.boxOk": "원래대로예요 ✓ · #1~#{n} 사슬이 끊김 없이 이어져요",
  "admin.integ.boxBad": "어긋남 · #{seq}부터 사슬을 믿을 수 없어요",
  "admin.integ.sumOk": "{n}건 모두 원래대로예요 ✓ · 외부 고정점 {date} 일치",
  "admin.integ.sumBad": "#{seq}에서 처음 어긋났어요. 그 뒤 {n}건은 믿을 수 없어요.",
  "admin.integ.auto": "매일 자동으로 검사해요 · 마지막 고정점 서명 {at}",
  "admin.integ.ranAt": "방금 검사했어요 · {at}",
  "admin.integ.run": "지금 검사",
  "admin.integ.running": "검사하는 중…",
  "admin.integ.demo": "한 행을 몰래 고쳐 보기",
  "admin.integ.demoNote": "제품에는 없는 단추예요. 이력 #{seq}의 세부를 잠깐 바꿔 검사하고 바로 원래대로 되돌렸어요. 실제 이력은 바뀌지 않았어요.",
  "admin.integ.sumDemo": "목업 전용: #{seq}에서 처음 어긋났을 때의 검사 결과예요. 그 뒤 {n}건은 믿을 수 없어요.",
  "admin.integ.chain": "최근 이력 사슬",
  "admin.integ.anchor": "외부 고정점 {date} · #{seq}까지",
  "admin.integ.afterAnchor": "오늘 이력은 자정 뒤 고정점에 들어가요",
  "admin.integ.noPerm": "위변조 검사 권한이 있어야 해요",
  "admin.integ.logged": "검사했어요. 검사한 일도 이력에 남았어요.",
  "admin.integ.blockOk": "원래대로",
  "admin.integ.blockBad": "어긋남",
  "admin.grade.q": "이력은 얼마나 오래 남나요?",
  "admin.grade.tech": "보관 등급 · 법정 하한 아래로 내릴 수 없어요",
  "admin.grade.sum": "권한 변경은 3년, 접속기록은 2년, 일반 운영은 1년 남겨요.",
  "admin.grade.3y": "권한·계정 · 3년",
  "admin.grade.3y.d": "역할·권한 부여·변경·회수, 2인 승인 결정, 사용자 만들기·정지·복구",
  "admin.grade.2y": "접속기록 · 2년(최소 1년)",
  "admin.grade.2y.d": "글 열람 허가·거부, 개인별 보기, 내보내기, 로그인, 이력 조회·검사",
  "admin.grade.1y": "일반 운영 · 1년",
  "admin.grade.1y.d": "정책·설정 변경, 보관 정리, 연결 토큰 발급·폐기",
  "admin.audlist.q": "누가 언제 무엇을 보고 바꿨나요?",
  "admin.audlist.tech": "열람·변경 이력 · 최근 순 · 행을 누르면 해시까지 보여요",
  "admin.audlist.sum": "이 조건에서 {n}건이고, 그중 거부·실패가 {d}건이에요.",
  "admin.audlist.kinds": "종류",
  "admin.audlist.person": "사람",
  "admin.audlist.personAll": "모든 사람",
  "admin.audlist.search": "대화 번호·세부 내용 찾기",
  "admin.audlist.clear": "조건 지우기",
  "admin.audlist.cond": "조건",
  "admin.audlist.condTitle": "이력 조건",
  "admin.audlist.condN": "조건 {n}",
  "admin.audlist.empty": "이 조건에 맞는 이력이 없어요.",
  "admin.audlist.emptyNot": "이력이 없다고 아무 일도 없던 건 아닐 수 있어요. 기간이나 조건을 넓혀 보세요.",
  "admin.audlist.suggest": "‘{kind}’ 조건을 빼면 {n}건 있어요",
  "admin.audlist.col.when": "시각",
  "admin.audlist.col.what": "무엇을",
  "admin.audlist.col.who": "누가(역할)",
  "admin.audlist.col.target": "대상",
  "admin.audlist.col.cat": "사유 범주",
  "admin.audlist.col.result": "결과",
  "admin.audlist.conv": "대화 #{no}",
  "admin.audlist.viewLogged": "이 화면을 연 일도 이력에 남아요.",
  "admin.k.content_ok": "글 열람(성공)",
  "admin.k.content_denied": "글 열람(거부)",
  "admin.audrow.title": "이력 #{seq}",
  "admin.audrow.time": "시각",
  "admin.audrow.action": "행위",
  "admin.audrow.actor": "누가",
  "admin.audrow.target": "대상",
  "admin.audrow.reason": "사유",
  "admin.audrow.detail": "세부",
  "admin.audrow.grade": "보관 등급",
  "admin.audrow.hash": "해시",
  "admin.audrow.prev": "이전 해시",
  "admin.audrow.anchor": "외부 고정점",
  "admin.audrow.case": "조사 건",
  "admin.audrow.koOnly": "세부 내용은 한국어로만 남았어요",
  "admin.audrow.grade.3y": "3년",
  "admin.audrow.grade.2y": "2년",
  "admin.audrow.grade.1y": "1년",
  "admin.act.login": "로그인",
  "admin.act.login.failed": "로그인 실패",
  "admin.act.role.change": "역할 변경",
  "admin.act.role.create": "역할 만들기",
  "admin.act.approval.request": "승인 요청",
  "admin.act.approval.approve": "승인",
  "admin.act.approval.reject": "거절",
  "admin.act.approval.withdraw": "요청 거둠",
  "admin.act.case.approve": "조사 건 승인",
  "admin.act.case.close": "조사 건 끝냄",
  "admin.act.policy.change": "정책 변경",
  "admin.act.notice.publish": "안내문 게시",
  "admin.act.content.view": "글 열람",
  "admin.act.content.grant": "대화 열람 허가",
  "admin.act.person.view": "개인별 보기",
  "admin.act.export": "내보내기",
  "admin.act.consent.change": "동의 변경",
  "admin.act.connection.add": "도구 연결",
  "admin.act.deletion.request": "삭제 요청",
  "admin.act.deletion.process": "삭제 처리",
  "admin.act.deletion.cancel": "삭제 요청 취소",
  "admin.act.retention.run": "보관 정리",
  "admin.act.legal_hold.set": "법적 보관 지정",
  "admin.act.legal_hold.release": "법적 보관 해제",
  "admin.act.apikey.rotate": "API 키 교체",
  "admin.act.key.rotate": "암호화 키 교체",
  "admin.act.token.revoke": "연결 토큰 폐기",
  "admin.act.sa.create": "서비스 계정 만들기",
  "admin.act.sa.token": "서비스 계정 토큰 다시 발급",
  "admin.act.sa.suspend": "서비스 계정 정지·다시 켬",
  "admin.act.audit.view": "열람·변경 이력 조회",
  "admin.act.audit.verify": "위변조 검사",
  "admin.act.audit.review": "월간 점검 결과",
  "admin.act.org.sync": "조직 보고서 동기화",
  "admin.act.price.version": "단가표 새 버전",
  "admin.dx.applied": "{id} 승인 반영",
  "admin.dx.perm": "{role} · {perm} {sFrom} → {sTo}",
  "admin.dx.undo": "되돌림",
  "admin.dx.id": "{id}",
  "admin.dx.roleOnly": "{role}",
  "admin.dx.permTo": "{perm} → {scope}",
  "admin.dx.grant": "{role} 역할 줌",
  "admin.dx.ungrant": "{role} 역할 거둠",
  "admin.dx.teams": "팀 {teams}",
  "admin.dx.until": "{date}까지",
  "admin.dx.roleCreate": "{name} · {role} 복사",
  "admin.dx.roleRemoved": "{name} 역할 지움",
  "admin.dx.roleRestored": "{name} 역할 되살림",
  "admin.dx.caseReq": "{id} · {case} · 대상 {n}명",
  "admin.dx.saStatus": "{name} · {st1} → {st2}",
  "admin.dx.name": "{name}",
  "admin.dx.notice": "안내문 {v1} → {v2} · 바뀐 절 {secs} · 재동의 요청",
  "admin.dx.holdSet": "보관 기간 만료 삭제 보류 · {ymd}까지",
  "admin.dx.holdRelease": "#{seq}에서 지정한 보관을 풂",
  "admin.dx.verifyOk": "{n}건 사슬 · 원래대로",
  "admin.dx.verifyBad": "{n}건 사슬 · #{seq}부터 어긋남",
  "admin.dx.verifyAnchor": "{n}건 사슬 · 고정값과 다름",
  "admin.dx.anchor": "{date} 고정값과 맞춰 봄",
  "admin.dx.review": "{month} 월간 점검 · {verdict}",
  "admin.dx.csv": "열람·변경 이력 {n}건 · CSV(가명)",
  "admin.dx.csvId": "열람·변경 이력 {n}건 · CSV(실명)",
  "admin.dx.orgSync": "Anthropic · OpenAI",
  "admin.dx.device": "기기",
  "admin.dx.saToken": "{name} · 전용 토큰 다시 발급",
  "admin.dx.price": "{date}부터 쓰는 단가표 · 모델 {n}개",
  "admin.rep.title": "월간 점검 보고서",
  "admin.rep.kicker": "{range} · 접속기록 점검",
  "admin.rep.lead": "관리자의 글 열람은 관리자가 아닌 감사 기록 검토자가 점검해요(직무 분리).",
  "admin.rep.byViewer": "열람자별 글 열람",
  "admin.rep.byTarget": "대상별 글 열람",
  "admin.rep.offHours": "업무 시간 밖 열람(9시 전·18시 뒤·주말)",
  "admin.rep.exports": "내보내기",
  "admin.rep.perms": "권한 변경",
  "admin.rep.cases": "조사 건·통지 유예",
  "admin.rep.none": "없어요",
  "admin.rep.viewRow": "{who} · {n}건(거부 {d})",
  "admin.rep.targetRow": "{who} · {n}건",
  "admin.rep.result": "확인 결과",
  "admin.rep.ok": "이상 없음",
  "admin.rep.check": "조사 필요",
  "admin.rep.memo": "메모(선택)",
  "admin.rep.save": "점검 결과 남기기",
  "admin.rep.saved": "점검 결과를 이력에 남겼어요.",
  "admin.rep.noPerm": "점검 결과는 감사 기록 검토자나 관리자가 남겨요.",
  "admin.csv.title": "열람·변경 이력 내보내기",
  "admin.csv.kicker": "CSV · {n}행",
  "admin.csv.head": "머리말 미리보기",
  "admin.csv.identity": "실명 넣기",
  "admin.csv.identityOff": "실명 포함 내보내기 권한이 없어 가명으로 내보내요.",
  "admin.csv.rules": "수식으로 읽히는 칸(=·+·-·@로 시작)은 앞에 따옴표를 붙여 막아요. 파일은 서버에 남기지 않고, 한 번에 1만 행까지 내보내요.",
  "admin.csv.download": "내려받기",
  "admin.csv.done": "CSV 파일을 내려받았어요. 내보낸 일도 이력에 남았어요.",
  "admin.csv.noPerm": "행 내보내기 권한이 있어야 해요",
  "admin.csv.h.id": "내보내기 번호",
  "admin.csv.h.by": "만든 사람 역할",
  "admin.csv.h.range": "기간",
  "admin.csv.h.filter": "조건",
  "admin.csv.h.ban": "금지 용도",
  "admin.csv.h.banText": "인사 평가·근태·감시에 쓰지 않아요",
  "admin.csv.h.limit": "가림 한계",
  "admin.sys.desc": "마지막 수신 {rel} · 회사 전체 기준 · {asof} 기준",
  "admin.sys.kpi.today": "오늘 받은 기록",
  "admin.sys.kpi.todayHint": "중복 {d} · 규칙상 저장 안 함 {x}",
  "admin.sys.kpi.last": "마지막 수신",
  "admin.sys.kpi.lastHint": "수집 서버 · {formats}",
  "admin.sys.kpi.conn": "연결됨",
  "admin.sys.kpi.connHint": "연결 {n}개 중 · 오류 {p} · 연결 안 됨 {d} · 조용함 {q}",
  "admin.sys.kpi.gaps": "수집 공백",
  "admin.sys.kpi.gapsHint": "서버 {s}번 · 기기 {d}번 · 가장 길게 {m}",
  "admin.sys.c1.error": "최근 수신 오류 · 집계 갱신 시각",
  "admin.sys.c1.q": "CLI 기록은 서버에 잘 들어오나요?",
  "admin.sys.c1.tech": "C1 서버 직접 수신 · OTLP/HTTP 로그·지표",
  "admin.sys.c1.sum": "오늘 {n}건을 받았고, 마지막 수신은 {rel}이에요.",
  "admin.sys.c1.received": "오늘 받음",
  "admin.sys.c1.dup": "중복(한 번만 셈)",
  "admin.sys.c1.dropped": "버림",
  "admin.sys.c1.droppedHint": "최근 30일 이유: 규칙상 {p} · 금지 항목 {f} · 형식 오류 {i}",
  "admin.sys.c1.rejected": "거절(연결 토큰 만료)",
  "admin.sys.c1.rejectedV": "{n}대에서 보낸 기록",
  "admin.sys.c1.formats": "받는 형식",
  "admin.sys.c1.queue": "처리 중인 수신 요청",
  "admin.sys.c1.loss": "서버 직접 수신만 쓰는 동안에는 서버가 멈춘 구간의 기록을 잃을 수 있어요. 최근 30일 서버 공백 {n}번 · 모두 {m}분.",
  "admin.sys.c3.q": "API 키 호출은 게이트웨이를 잘 지나나요?",
  "admin.sys.c3.tech": "C3 API 게이트웨이 · 게이트웨이 토큰 필수",
  "admin.sys.c3.sum": "이 기간 호출은 {n}건이고 오류율은 {r}이에요.",
  "admin.sys.c3.calls": "호출",
  "admin.sys.c3.err": "오류율",
  "admin.sys.c3.errV": "{r}({e}/{n}건)",
  "admin.sys.c3.cli": "CLI(게이트웨이 경유)",
  "admin.sys.c3.cliV": "{n}건 · 중복 확인 중",
  "admin.sys.c3.routes": "열어 둔 경로",
  "admin.sys.c3.emptyWhat": "이 기간에 게이트웨이를 거친 호출이 없어요.",
  "admin.sys.c3.emptyNot": "게이트웨이를 거친 호출만 여기에 보여요. API 키를 안 쓴 건 아닐 수 있어요.",
  "admin.sys.c4.q": "조직 보고서는 제때 받았나요?",
  "admin.sys.c4.tech": "C4 조직 사용량·비용 보고서 · 하루 단위 · 사람별 아님",
  "admin.sys.c4.sumOk": "두 회사 보고서를 모두 제때 받았어요.",
  "admin.sys.c4.sumWarn": "{p}{eun} 확인이 필요해요.",
  "admin.sys.c4.lastSync": "마지막 동기화 {at}",
  "admin.sys.c4.keysLabel": "키 등록부",
  "admin.sys.c4.keys": "조직 연동 키 {a}개 · 직접 등록 {m}개",
  "admin.sys.c4.period": "이 기간 {d}일치 · 키 {k}개 · {usd}",
  "admin.sys.c4.periodNone": "이 기간에 받은 조직 보고서가 없어요",
  "admin.sys.c4.sync": "지금 동기화",
  "admin.sys.c4.syncing": "조직 사용량 보고서를 동기화하는 중이에요",
  "admin.sys.c4.synced": "동기화를 마쳤어요 · 결과는 수집 상태의 ‘조직 보고서는 제때 받았나요?’ 카드에 보여요",
  "admin.sys.c4.requested": "방금 동기화를 요청했어요",
  "admin.sys.c4.noPerm": "연동 관리 권한이 있어야 해요",
  "admin.sys.c4.emptyWhat": "Admin 키가 없어 조직 보고서를 받지 못했어요.",
  "admin.sys.c4.emptyNot": "사람별 기록(CLI·게이트웨이)은 그대로 들어와요. 조직 합계만 비어요.",
  "admin.sys.c4.howTo": "Admin 키 연결 방법",
  "admin.sys.c2.q": "PC 도우미는 켜져 있나요?",
  "admin.sys.c2.tech": "C2 PC 도우미 · 선택 모듈(2차 범위)",
  "admin.sys.c2.sum": "선택 모듈이라 꺼져 있어요. 시범 기기 {n}대 중 {p}대에 오류가 있어요.",
  "admin.sys.c2.module": "모듈",
  "admin.sys.c2.moduleV": "관리자가 켜야 연결 마법사에 보여요",
  "admin.sys.c2.pilot": "시범 기기",
  "admin.sys.c2.noResp": "오류가 있는 기기",
  "admin.gap.q": "기록이 끊긴 때가 있었나요?",
  "admin.gap.tech": "수집 공백 띠 · 서버 전체 / 기기 하나 · 한국 시간",
  "admin.gap.sum": "이 기간 서버 전체 공백 {s}번, 기기 하나의 공백 {d}번이 있었어요.",
  "admin.gap.sumNone": "이 기간에는 수집 공백이 없어요.",
  "admin.gap.server": "서버 전체 공백",
  "admin.gap.device": "기기 하나의 공백",
  "admin.gap.alerted": "30분 넘어 알림 보냄",
  "admin.gap.ongoing": "지금도 이어지는 중",
  "admin.gap.band": "수집 공백 시간축",
  "admin.gap.zoomIn": "확대 +",
  "admin.gap.zoomOut": "축소 −",
  "admin.gap.zoomHint": "공백 조각이나 [확대 +]를 누르면 그 공백 앞뒤 1시간만 크게 펼쳐요.",
  "admin.gap.zoomed": "확대해서 보는 중 · {range}",
  "admin.gap.zoomTo": "눌러서 이 공백 확대",
  "admin.gap.prev": "이전 공백",
  "admin.gap.next": "다음 공백",
  "admin.gap.rule": "업무 시간에 서버 전체 수신이 30분 넘게 0건이면 관리자·운영 담당에게 알려요. 그 구간의 값은 ‘기록 없음 · 서버가 받지 못한 구간’으로 보여요.",
  "admin.gap.emptyNot": "공백이 없다고 모든 기기가 보낸 건 아니에요. 기기별 연결은 도구 연결에서 보세요.",
  "admin.daily.q": "날마다 기록을 잘 받았나요?",
  "admin.daily.tech": "저장함 · 규칙상 저장 안 함 · 중복 · 한국 시간",
  "admin.daily.sum": "가장 많이 받은 날은 {day}{ie}({v}).",
  "admin.daily.limit": "수신 통계는 최근 30일치만 보여요.",
  "admin.daily.stored": "저장함",
  "admin.daily.dropped": "규칙상 저장 안 함",
  "admin.daily.dup": "중복",
  "admin.daily.when": "날짜",
  "admin.daily.emptyWhat": "이 기간에 받은 기록이 없어요.",
  "admin.daily.emptyNot": "받은 기록이 없다고 수집이 멈춘 건 아니에요. 주말·휴일에는 적어요.",
  "admin.drop.q": "버린 기록은 왜 버렸나요?",
  "admin.drop.tech": "최근 30일 · 이유별 건수 · 값은 남기지 않아요",
  "admin.drop.sum": "가장 많은 이유는 ‘{r}’({p})예요.",
  "admin.drop.policy": "규칙상 저장 안 함",
  "admin.drop.policy.d": "동의·기록 수준 밖",
  "admin.drop.forbidden.d": "중간 생각·본문 등",
  "admin.drop.invalid.d": "형식이 맞지 않음",
  "admin.drop.forbidden": "금지 항목",
  "admin.drop.invalid": "형식 오류",
  "admin.unk.q": "처음 보는 이름이 들어왔나요?",
  "admin.unk.tech": "처음 보는 이벤트·속성 이름 · 이름·건수만 세요",
  "admin.unk.sum": "처음 보는 이름 {n}개가 들어왔어요. 지원표에 넣을지 확인하세요.",
  "admin.ver.q": "새 CLI 버전을 확인하고 있나요?",
  "admin.ver.tech": "지원 버전 정책 · 최소 지원 · 확인 중 · 연결별 버전",
  "admin.ver.sum": "{tool} {ver}{eul} 확인하고 있어요. 확인 전까지 글·작업 상세에 ‘확인 중’ 표시를 붙여요.",
  "admin.ver.sumNone": "확인 중인 새 버전이 없어요.",
  "admin.ver.min": "최소 지원",
  "admin.ver.latest": "확인한 최신",
  "admin.ver.checking": "확인 중",
  "admin.ver.checked": "마지막 확인 {date}",
  "admin.ver.inUse": "쓰는 버전",
  "admin.ver.conn": "{v} · 연결 {n}개",
  "admin.hl.q": "서버는 건강한가요?",
  "admin.hl.tech": "실행 단위 3개 · 저장 공간 · 키·백업",
  "admin.hl.sum": "실행 단위 3개가 모두 일하고 있어요. 저장 공간은 {p}를 썼어요.",
  "admin.hl.collector": "수집 서버",
  "admin.hl.collectorV": "마지막 수신 {rel}",
  "admin.hl.api": "화면 API",
  "admin.hl.apiV": "이 화면을 방금 불러왔어요",
  "admin.hl.worker": "배치 작업자",
  "admin.hl.workerV": "보관 정리 {a} · 조직 보고서 동기화 {b}",
  "admin.hl.sumUnknown": "실행 단위는 응답하고 있지만 저장 공간 사용량은 확인하지 못했어요.",
  "admin.hl.sumUnknownWarn": "실행 단위 {n}개를 확인해야 해요. 저장 공간 사용량은 확인하지 못했어요.",
  "admin.hl.volume": "서버 디스크 사용량",
  "admin.sys.pathPending": "이 수집 경로는 연결과 검증을 준비 중이에요.",
  "admin.hl.storage": "저장 공간",
  "admin.hl.storageV": "{used} / {total}",
  "admin.hl.keys": "암호화 키",
  "admin.hl.keysV": "마지막 교체 {date}",
  "admin.hl.backup": "DB 백업",
  "admin.hl.backupV": "30일 이하로 보관 · 암호화 키는 백업과 따로 보관해요",
  "admin.cost.desc": "단가표 {v} 버전 · 비용 종류 4가지는 서로 더하지 않아요",
  "admin.cost.toStats": "통계에서 비용 보기",
  "admin.kinds.q": "비용은 어떤 종류가 있나요?",
  "admin.kinds.tech": "비용 종류 4가지 · 계산 방법이 달라 더하지 않아요",
  "admin.kinds.sum": "이 조건에서 CLI 도구 추정 {a} · 비공식 {b} · 단가표 계산 {c} · 조직 청구 {d}예요(서로 더하지 않아요).",
  "admin.kinds.why": "같은 호출이 두 출처에 함께 잡힐 수 있고(예: 게이트웨이를 거친 CLI), 단가·할인·반올림이 달라 더하면 틀린 합계가 돼요.",
  "admin.kinds.src": "어디서",
  "admin.kinds.how": "어떻게",
  "admin.kinds.basis": "대화 {n}건",
  "admin.kinds.basisOrg": "키 {k}개 · {d}일",
  "admin.kind.cli": "CLI 도구 추정",
  "admin.kind.cli.src": "Claude Code가 보낸 cost_usd",
  "admin.kind.cli.how": "도구가 자체 가격으로 계산한 값이에요.",
  "admin.kind.cli.tag": "추정 · 청구서 아님",
  "admin.kind.unofficial": "비공식(Codex)",
  "admin.kind.unofficial.src": "Codex turn_cost(비공식 값)",
  "admin.kind.unofficial.how": "공식 문서에 없는 값이라 오지 않을 수 있어요.",
  "admin.kind.unofficial.tag": "비공식 · 청구서 아님",
  "admin.kind.gateway": "단가표 계산",
  "admin.kind.gateway.src": "게이트웨이 사용량 × 아래 단가표",
  "admin.kind.gateway.how": "호출한 날의 가격 버전으로 계산해요.",
  "admin.kind.gateway.tag": "계산 · 청구서 아님",
  "admin.kind.org": "조직 청구",
  "admin.kind.org.src": "AI 회사 조직 보고서(하루 단위)",
  "admin.kind.org.how": "AI 회사가 알려 준 청구 기준 금액이에요. 사람별로 나눌 수 없어요.",
  "admin.kind.org.tag": "청구 기준 · 사람별 아님",
  "admin.price.q": "어떤 단가로 계산하나요?",
  "admin.price.tech": "단가표 · 가격 버전 · USD / 100만 토큰 · 예시 값",
  "admin.price.sum": "지금은 {v} 버전이고, 직전 버전보다 바뀐 단가는 {n}개예요.",
  "admin.price.sumFirst": "지금은 {v} 버전이에요.",
  "admin.price.ver": "가격 버전",
  "admin.price.verCur": "{v}(지금)",
  "admin.price.verNext": "{v}(예정)",
  "admin.price.verOld": "{v}(지난)",
  "admin.price.range": "{from}부터 적용",
  "admin.price.rangeTo": "{from} ~ {to} 적용",
  "admin.price.col.provider": "AI 회사",
  "admin.price.col.model": "AI 모델",
  "admin.price.unit": "단위: USD / 100만 토큰",
  "admin.price.changed": "직전 버전과 다른 값",
  "admin.price.new": "새 가격 버전 만들기",
  "admin.price.rule1": "적용 시작일부터 새 단가로 계산하고, 지난 계산은 그때의 가격 버전을 그대로 둬요.",
  "admin.price.rule2": "단가표에 없는 모델의 호출에는 ‘단가표에 없어 비용을 계산하지 않았어요’ 배지를 달아요.",
  "admin.price.rule3": "모델 이름·가격은 목업용 예시 값이에요.",
  "admin.price.dlgTitle": "새 가격 버전",
  "admin.price.from": "적용 시작일",
  "admin.price.fromHint": "내일 이후 날짜만 고를 수 있어요.",
  "admin.price.copyNote": "지금 버전 값을 복사해 두었어요. 바꿀 칸만 고치세요.",
  "admin.price.save": "예약하기",
  "admin.price.saved": "{v} 가격 버전을 예약했어요.",
  "admin.price.errNum": "단가는 0 이상 1,000 이하 숫자로 적어 주세요.",
  "admin.price.errDate": "적용 시작일을 내일 이후로 고르세요.",
  "admin.price.errDup": "같은 날짜의 가격 버전이 이미 있어요.",
  "admin.bud.q": "팀별 예산·한도를 정할 수 있나요?",
  "admin.bud.tech": "예산·한도 · 선택 모듈",
  "admin.bud.badge": "2차 범위",
  "admin.bud.sum": "아직 켜지 않은 선택 모듈이에요. 켜면 팀별 월 한도와 90% 알림을 정해요.",
  "admin.bud.col.team": "팀",
  "admin.bud.col.month": "이번 달 단가표 계산",
  "admin.bud.col.limit": "월 한도",
  "admin.bud.noLimit": "정하지 않음",
  "admin.bud.small": "소규모 팀 합산",
  "admin.roles.bundleCount": "묶음 권한 {total}개 중 {n}개",
  "admin.bud.smallSub": "{t}개 팀 · {n}명(3명보다 적은 팀)",
  "admin.bud.rule": "90%에서 알리고, 100%에서 막을지는 고를 수 있어요(게이트웨이 경로만).",
  "admin.bud.enable": "예산 모듈 켜기",
  "admin.bud.enableNo": "2차 범위(선택 모듈)라 아직 켤 수 없어요",
  "admin.bud.monthNote": "단가표 계산 비용 기준 · 청구서 아님 · {range}",
  "admin.bud.smallHidden": "3명보다 적은 팀 · 합쳐도 3명보다 적어 값을 가렸어요",
  "admin.pol.descOps": "운영 담당은 이 화면에서 삭제 요청만 처리해요. 다른 정책은 관리자가 정해요.",
  "admin.del.col.scope": "무엇을",
  "admin.del.col.when": "요청",
  "admin.del.col.due": "자동 삭제",
  "admin.del.col.act": "처리",
  "admin.del.records": "대화 {n}건",
  "admin.del.auto": "동의 철회로 자동",
  "admin.del.st.pending": "처리 대기",
  "admin.del.st.done": "삭제함",
  "admin.del.st.held": "보류(법적 보관)",
  "admin.del.st.rejected": "반려",
  "admin.del.by": "{who} · {when}",
  "admin.del.do.delete": "삭제",
  "admin.del.do.hold": "보류",
  "admin.del.do.reject": "반려",
  "admin.del.dlg.delete": "이 요청을 삭제할까요?",
  "admin.del.dlg.hold": "법적 보관으로 보류할까요?",
  "admin.del.dlg.reject": "이 요청을 반려할까요?",
  "admin.del.lead.delete": "{who}의 {what}({n})에서 글과 식별자를 지워요. 비용 정산용 사용량은 가명·집계로 남아요. 결과는 당사자 화면에 보여요.",
  "admin.del.lead.hold": "법적 보관 중인 기록이라 지우지 않고 보류해요. 조회 차단은 그대로이고, 보관이 풀리면 다시 처리해요. 메모는 당사자 화면에 보여요.",
  "admin.del.lead.reject": "반려하면 조회 차단이 풀려 기록이 다시 보여요. 반려 사유는 당사자 화면에 보여요.",
  "admin.del.memo": "메모(당사자에게 보여요)",
  "admin.del.memoReq": "메모를 5자 이상 적어 주세요.",
  "admin.del.memoHint": "보류·반려는 메모가 꼭 필요해요. 삭제는 메모 없이도 돼요.",
  "admin.del.holdOnly": "법적 보관 중이라 삭제할 수 없어요 — 보류로 처리하세요",
  "admin.del.toast.delete": "삭제했어요 · 당사자 화면에 결과가 보여요",
  "admin.del.toast.hold": "보류했어요 · 조회 차단은 그대로예요",
  "admin.del.toast.reject": "반려했어요 · 기록이 다시 보여요",
  "admin.del.blockNote": "처리 전에도 요청한 기록은 모든 역할의 목록·상세·합계에서 이미 빠져 있어요(조회 차단).",
  "admin.sys.c1.queueV": "{n}건 처리 중 · 가장 오래 처리 중인 요청 {s}초",
  "admin.sys.c1.queueHint": "동시에 최대 {limit}개 · {rel} 기준",
  "admin.ver.legacy": "옛 PoC 설정이 남은 기기",
  "admin.ver.legacyV": "{n}대",
  "admin.ver.legacyHint": "기록이 옛 시험 서버로도 갈 수 있어요. 당사자의 도구 연결 화면에 정리 방법이 떠 있어요.",
  "admin.hl.byKind": "종류별",
  "admin.hl.kind.content": "질문·답변 글·작업 상세",
  "admin.hl.kind.usage": "사용량·기본 정보",
  "admin.hl.kind.audit": "열람·변경 이력",
  "admin.hl.kind.other": "그 밖(설정·용어집·캐시)",
  "admin.hl.backupLast": "마지막 백업 {at} · {size} · 30일 이하로 보관",
  "admin.hl.keyBackup": "키 백업",
  "admin.hl.keyBackupV": "마지막 {at} · 키 {v} · 백업과 따로 보관",
};

export default admin;
